import { Link } from "react-router-dom";
import { Play, Eye, TrendingUp } from "lucide-react";
import { mediaUrl } from "../lib/media";

export default function VideoCard({ video, kind = "viral", size = "md" }) {
    const to = kind === "viral" ? `/watch/viral/${video.id}` : `/watch/ai/${video.id}`;
    const width = size === "lg" ? "w-[380px]" : "w-[320px]";
    return (
        <Link
            to={to}
            data-testid={`video-card-${video.id}`}
            className={`group relative shrink-0 ${width} snap-start`}
        >
            <div className="relative aspect-video rounded-[18px] overflow-hidden bg-white/5 border border-white/5">
                <img
                    src={mediaUrl(video.thumbnail)}
                    alt={video.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                {video.trending && (
                    <span className="absolute top-3 left-3 inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider bg-[#FFD400] text-black px-2 py-1 rounded">
                        <TrendingUp className="w-3 h-3" /> Trending
                    </span>
                )}
                <span className="absolute bottom-3 right-3 text-[11px] text-white/90 bg-black/60 backdrop-blur-md rounded px-2 py-0.5 border border-white/10">
                    {video.duration}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="w-14 h-14 rounded-full bg-[#FFD400] flex items-center justify-center">
                        <Play className="w-6 h-6 fill-black text-black translate-x-0.5" />
                    </span>
                </div>
            </div>
            <div className="mt-3 px-1">
                <h3 className="font-display font-semibold text-white leading-snug line-clamp-2">
                    {video.title}
                </h3>
                <div className="mt-1 flex items-center gap-3 text-xs text-white/50">
                    <span className="inline-flex items-center gap-1">
                        <Eye className="w-3 h-3" /> {video.views}
                    </span>
                    <span>{video.category}</span>
                </div>
            </div>
        </Link>
    );
}
